const defaultTransition = v =>
  `transform ${v}s ease-in-out, color ${v}s ease-in-out, background-color ${v}s ease-in-out, border-color ${v}s ease-in-out, box-shadow ${v}s ease-in-out`;

export { defaultTransition };
